// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class OERateDisplayModel {
  ////
  public bidValue: CubiqTS.BigNumber = null;
  public bidStr: string = "";

  public offerValue: CubiqTS.BigNumber = null;
  public offerStr: string = "";

  public divider: string = "/";
  public invalid: boolean = false;
  public empty: boolean = false;

  constructor() {}

  // reset display
  public reset(): void {
    this.bidStr = "";
    this.divider = "/";
    this.offerStr = "";
    this.bidValue = null;
    this.offerValue = null;
    this.invalid = false;
  }

  public static empty(): OERateDisplayModel {
    let model = new OERateDisplayModel();
    model.bidStr = "0.0000";
    model.divider = "/";
    model.offerStr = "0.0000";
    model.bidValue = new CubiqTS.BigNumber(0);
    model.offerValue = new CubiqTS.BigNumber(0);
    model.invalid = true;
    model.empty = true;
    return model;
  }

  public invalidate(): void {
    this.bidStr = "-";
    this.divider = "/";
    this.offerStr = "-";
    this.bidValue = null;
    this.offerValue = null;
    this.invalid = true;
  }
}
